<template>
  <dialog-add
    icon="inventory"
    :title="$t('create_event_promotion')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
    class="promotion-theming-dialog"
  >
    <template v-slot:content>
      <forms-events-promotion-theming class="elevation-1" />
    </template>
  </dialog-add>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$router.push('/events/promotions');
    },
  },
};
</script>
